import React, { Component } from "react";
import { DIMENSIONS } from "utils/Dimensions";

export default class FormulaColumnEditor extends Component {
  formulaHelpText =
    "This is a non-editable cell. To make changes to the formula, please\
  select Edit Field from the header menu.";
  workflowHelpText = "To change a workflow status column, use the buttons";
  defaultHelpText = "This is non-editable cell";

  constructor(props) {
    super(props);

    const columnTypeId = props.colDef.cellRendererParams.columnTypeId;

    this.state = {
      value: props.value ? props.value : "",
    };

    if (columnTypeId == 3 && props.colDef.headerName == "Workflow Status") {
      this.readOnlyText = this.workflowHelpText;
    } else if (columnTypeId == 7 || columnTypeId == 19) {
      this.readOnlyText = this.formulaHelpText;
    } else {
      this.readOnlyText = this.defaultHelpText;
    }

    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(
      this
    );
  }

  componentDidMount() {
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
  }

  componentWillUnmount() {
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
  }

  focusNextCell = (rowIndex, colId) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    this.props.api.setFocusedCell(rowIndex, colId);
  };

  getColIds = () => {
    var nextColId = "",
      prevColId = "",
      columnDefs = this.props?.columnApi?.columnController?.columnDefs;
    for (let i = 0; i < columnDefs.length; i++) {
      if (columnDefs[i]["colId"] === this.props.colDef.colId) {
        nextColId =
          columnDefs[i + 1 === columnDefs.length - 1 ? i : i + 1]["colId"];
        prevColId = columnDefs[i - 1 < 0 ? i : i - 1]["colId"];
        break;
      }
    }
    return { nextColId: nextColId, prevColId: prevColId };
  };

  arrowKeyNavigation = (event) => {
    event.preventDefault();
    var { nextColId, prevColId } = this.getColIds();
    if ([37].indexOf(event.keyCode) > -1) {
      this.focusNextCell(this.props.rowIndex, prevColId);
    }
    if ([38].indexOf(event.keyCode) > -1)
      this.focusNextCell(
        this.props.rowIndex === 0 ? 0 : this.props.rowIndex - 1,
        this.props.column.colId
      );
    if ([39].indexOf(event.keyCode) > -1) {
      this.focusNextCell(this.props.rowIndex, nextColId);
    }
    if ([40].indexOf(event.keyCode) > -1)
      this.focusNextCell(
        this.props.rowIndex + 2 < this.props.agGridReact.props.rowData.length
          ? this.props.rowIndex + 1
          : this.props.rowIndex,
        this.props.column.colId
      );
  };

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return false;
  }

  focus() {
    window.setTimeout(() => {
      if(this.refs.input)
        this.refs.input.focus();
    });
  }

  render() {
    return (
      <div
        ref="container"
        className="formulaEditContainer"
        style={{
          width: Number(this.props.colDef.width) - 15,
          minHeight: this.props.node.rowHeight - 5,
        }}
      >
        {
          this.props?.colDef?.cellRendererParams?.columnTypeId == 12 ? (
            <div
              className="custom-control custom-checkbox"
              style={{
                width: Number(this.props.colDef.width) - 10,
                paddingTop:"10px",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <input
                ref="input"
                type="checkbox"
                className="custom-control-input"
                id="defaultChecked"
                checked={this.props.value == "1" ? true : false}
              />
              <label className="custom-control-label boolean-checkbox checkbox-pointer"></label>
            </div>
          ) : (
            <>
              <input
                ref="input"
                type="checkbox"
                className="custom-control-input"
                id="defaultChecked"
                onChange={() => {}}
                checked={false}
              />
              <div
                className="formulaEditValue"
                style={{
                  width: Number(this.props.colDef.width) - 15,
                  height: this.props.node.rowHeight,
                  overflow: 'hidden',
                  flexWrap: 'wrap',
                  marginTop: 5
                }}
              >
                {this.props.value}
              </div>
            </>
          )
        }
        <div
          className="formulaCellExtraText"
          style={{ top: DIMENSIONS.cell_height_short }}
        >
          {this.readOnlyText}
        </div>
      </div>
    );
  }
}
